import { render, staticRenderFns } from "./Notes.vue?vue&type=template&id=d8b50a60"
import script from "./Notes.vue?vue&type=script&lang=js"
export * from "./Notes.vue?vue&type=script&lang=js"
import style0 from "./Notes.vue?vue&type=style&index=0&id=d8b50a60&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RedactorInput: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/RedactorInput.vue').default,Toggle: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/Toggle.vue').default,FiltersBar: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/filters/Bar.vue').default,ErrorBlock: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/ErrorBlock.vue').default,NoteEntry: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/NoteEntry.vue').default,Pagination: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/Pagination.vue').default,ModalsNotesModal: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/modals/NotesModal.vue').default})
